export default __webpack_public_path__ + "static/media/station-location.75c86601.svg";